import { detect } from 'detect-browser';

const isSafeExternalURL = (url: string): boolean => {
  try {
    const { protocol } = new URL(url, window.location.href);
    return protocol === 'http:' || protocol === 'https:';
  } catch {
    return false;
  }
};

export const navigateToExternalURL = (url: string): void => {
  if (!isSafeExternalURL(url)) {
    return;
  }
  const browser = detect();

  if (browser) {
    if (browser.name === 'edge' && parseInt(browser.version) <= 18) {
      // Navigating to external page with href not supported in edge 18 and below
      // @ts-ignore
      window.location = encodeURI(url);
      return;
    }
  }
  window.location.href = encodeURI(url);
};
